var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLlline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "15, 10, 5, 10, 15",
    strokeWidth: 2,
    stroke: "#949494",
    d: "M0 10h600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLlline);
export default __webpack_public_path__ + "static/media/llline.e3516c7b79144ed8eb3f0c1ec36e7403.svg";
export { ForwardRef as ReactComponent };